import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

export default connect((state) => state)(
  class extends Component {
    delete = async () => {
      const { answer, courseId, onDataChange } = this.props;

      const response = await api.delete(
        `/admin/courses/${courseId}/answers/${answer.id}`
      );
      if (!response.data || !response.data.success) return false;

      await onDataChange();

      return true;
    };

    render() {
      const { messages } = this.props;

      return (
        <ConfirmButton
          actionText={messages.commonDelete}
          buttonIcon="trash-alt"
          buttonText={messages.commonDeleteAnswer}
          category="danger"
          confirmText={messages.commonDeleteAnswerConfirm}
          confirmTitle={messages.commonDeleteAnswer}
          onConfirm={this.delete}
          successMessage={messages.commonDeleteAnswerSuccess}
        />
      );
    }
  }
);
